<template>
  <el-row :class="isNotUserRequestCertificateClass">
    <!-- 页头  -->
    <el-col :span="24" class="header" v-show="isUserRequestCertificate">
      <el-col
        :span="10"
        class="logo"
        :class="collapsed ? 'logo-collapse-width' : 'logo-width'"
        style="font-size: 18px; font-weight: bold"
      >
        {{ collapsed ? "" : sysName }}
        <span style="font-size: 10px">{{ sysNo }}</span>
      </el-col>
      <el-col :span="10"> </el-col>
      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner"
            ><img src="../assets/user.png" /> {{ sysUserName }}</span
          >
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>我的消息</el-dropdown-item>
            <el-dropdown-item @click.native="updatePwd"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item divided @click.native="logout"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>

    <el-col :span="24" class="main">
      <!-- 侧边栏-->
      <aside
        :class="collapsed ? 'menu-collapsed' : 'menu-expanded'"
        v-show="isUserRequestCertificate"
      >
        <!--导航菜单-->
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          @open="handleopen"
          @close="handleclose"
          @select="handleselect"
          unique-opened
          router
          v-show="!collapsed"
        >
          <template v-for="(item, index) in roleData">
            <el-submenu :index="index + ''" v-bind:key="item.id">
              <template slot="title"
                ><i :class="item.iconCls"></i>{{ item.resName }}</template
              >
              <el-menu-item
                v-for="child in item.children"
                :index="child.resPath"
                :key="child.resPath"
                >{{ child.resName }}</el-menu-item
              >
            </el-submenu>
            <!-- <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item> -->
          </template>
        </el-menu>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col
            :span="24"
            class="breadcrumb-container"
            v-show="isUserRequestCertificate"
          >
            <strong class="title">{{ $route.name }}</strong>
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item
                v-for="item in $route.matched"
                :key="item.path"
              >
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>
  </el-row>
</template>
<script>
import { url } from "../api/api";
import { RequestGet } from "../api/api";
export default {
  data() {
    return {
      sysName: "五所业务服务平台",
      sysNo: "v1.0.0",
      collapsed: false,
      sysUserName: "",
      sysUserAvatar: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      roleData: [],
      isUserRequestCertificate: false,
      isNotUserRequestCertificateClass: "container",
    };
  },
  created: function () {
    RequestGet("/user/findCustomer")
      .then((response) => {
        console.log(this.$route.path);
        this.sysUserName = response.data.userName;
        //sessionStorage.setItem("communityId",response.data.communityId);
        sessionStorage.setItem("userId", response.data.id);
        sessionStorage.setItem("loginName", response.data.phone);
        sessionStorage.setItem("type", response.data.type);
        sessionStorage.setItem("enterpriseId", response.data.enterpriseId);
        (this.isUserRequestCertificate = true),
          (this.isNotUserRequestCertificateClass = "container");

        //sessionStorage.setItem("code",response.data.code);
        this.sysUserAvatar = "";

        this.roleData = [
          {
            id: "1e70c451586649fea1a0676c8db0d79f",
            resName: "个人信息",
            resPath: "#",
            parentId: "e6855215d11a448ca7f3564448c967a1",
            resIcon: null,
            resDesc: null,
            resOpen: "10",
            resSort: 3,
            state: "10",
            selected: true,
            children: [
              {
                id: "3c6a7d533db244d9b3054081602c6f35",
                resName: "个人信息修改",
                resPath: "modify",
                parentId: "1e70c451586649fea1a0676c8db0d79f",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 1,
                state: "10",
                selected: true,
                children: null,
              },
              {
                id: "8043570112d045c7a66f7720ccb919ca",
                resName: "绑定所属公司",
                resPath: "affiliate_company",
                parentId: "1e70c451586649fea1a0676c8db0d79f",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 2,
                state: "10",
                selected: true,
                children: null,
              },
              {
                id: "a2125457cc394dbd913eb5ffbb371996",
                resName: "收货地址管理",
                resPath: "cumstomer_addrList",
                parentId: "1e70c451586649fea1a0676c8db0d79f",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 2,
                state: "10",
                selected: true,
                children: null,
              },
            ],
          },
          {
            id: "08c5e2e2f38c46618df24ab72a91ff24",
            resName: "委托管理",
            resPath: "#",
            parentId: "e6855215d11a448ca7f3564448c967a1",
            resIcon: null,
            resDesc: null,
            resOpen: "10",
            resSort: 4,
            state: "10",
            selected: true,
            children: [
              {
                id: "f15aad4c09724ccdbe1aa84f3fe4b72f",
                resName: "委托下单",
                resPath: "chooseDept",
                parentId: "08c5e2e2f38c46618df24ab72a91ff24",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 1,
                state: "10",
                selected: true,
                children: null,
              },
              {
                id: "cfca587d7c71424baea2df134a5afe74",
                resName: "委托查询",
                resPath: "consignationQuery",
                parentId: "08c5e2e2f38c46618df24ab72a91ff24",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 2,
                state: "10",
                selected: true,
                children: null,
              },
              {
                id: "cfca587d7c71424bae123df134a5afe73",
                resName: "证书报告防伪验证中心",
                resPath: "/certificate",
                parentId: "08c5e2e2f38c46618df24ab72a91ff24",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 3,
                state: "10",
                selected: true,
                children: null,
              },
			  {
                id: "cfca587d7c71424bae123df134a5af100",
                resName: "企业信息",
                resPath: "/enterprise",
                parentId: "08c5e2e2f38c46618df24ab72a91ff24",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 3,
                state: "10",
                selected: true,
                children: null,
              },
              {
                id: "cfca587d7c71424bae123df134a5afe75",
                resName: "证书报告防伪验证中心",
                resPath: "/emailConSign",
                parentId: "08c5e2e2f38c46618df24ab72a91ff24",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 3,
                state: "10",
                selected: true,
                children: null,
              },
              {
                id: "cfca587d7c71424bae123df134a5afe76",
                resName: "证书报告防伪验证中心",
                resPath: "/quoteSignature",
                parentId: "08c5e2e2f38c46618df24ab72a91ff24",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 3,
                state: "10",
                selected: true,
                children: null,
              },
              {
                id: "cfca587d7c71424bae123df134a5afe77",
                resName: "问卷调查",
                resPath: "/questionnaire",
                parentId: "08c5e2e2f38c46618df24ab72a91ff24",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 3,
                state: "10",
                selected: true,
                children: null,
              },
            ],
          },
          {
            id: "7a08017009e5428c878ba3ffb358b37c",
            resName: "来访预约",
            resPath: "#",
            parentId: "e6855215d11a448ca7f3564448c967a1",
            resIcon: null,
            resDesc: null,
            resOpen: "10",
            resSort: 5,
            state: "10",
            selected: true,
            children: [
              {
                id: "dfc9c27eb52142098817b0bb54d42bd5",
                resName: "预约登记",
                resPath: "appointment",
                parentId: "7a08017009e5428c878ba3ffb358b37c",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 1,
                state: "10",
                selected: true,
                children: null,
              },
              {
                id: "858cec37f8cd49bfbadf67ddb6131bf2",
                resName: "预约记录",
                resPath: "record",
                parentId: "7a08017009e5428c878ba3ffb358b37c",
                resIcon: null,
                resDesc: null,
                resOpen: "10",
                resSort: 2,
                state: "10",
                selected: true,
                children: null,
              },
            ],
          },
        ];
      })
      .catch((error) => {
        // if(this.$route.path!='/certificate'){
        // 	this.$router.push({ path: '/login' });
        // }else{
        // 		this.isUserRequestCertificate=false,
        // 		this.isNotUserRequestCertificateClass=""
        // }
        if (
          this.$route.path === "/emailConSign" ||
          this.$route.path === "/quoteSignature" ||
          this.$route.path === "/questionnaire" ||
          this.$route.path === "/enterprise"
        ) {
          (this.isUserRequestCertificate = false),
            (this.isNotUserRequestCertificateClass = "");
        } else if (this.$route.path != "/certificate") {
          this.$router.push({ path: "/certificate" });
        } else {
          (this.isUserRequestCertificate = false),
            (this.isNotUserRequestCertificateClass = "");
        }
      });

    // 	  this.$axios.get(url+'/main/findVueMenus?='+'').then(response => {
    //          this.roleData = response.data.data;

    //         }).catch(error => {
    //           console.log(error)
    //   })
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
    handleopen() {
      //console.log('handleopen');
    },
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function (a, b) {},

    //修改密码
    updatePwd: function () {
      var _this = this;
      _this.$router.push("/updatePwd1");
    },
    //退出登录
    logout: function () {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          sessionStorage.removeItem("user");
          _this.$router.push("/login");
        })
        .catch(() => {});
    },
    //折叠导航栏
    collapse: function () {
      this.collapsed = !this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
  },
  mounted() {
    // var user = sessionStorage.getItem('user');
    // if (user) {
    // 	user = JSON.parse(user);
    // }
  },
};
</script>

<style scoped lang="scss">
@import "./element-variables";
#footer {
  position: fixed;
  bottom: 0;
  z-index: 999;
  width: 100%;

  background-color: rgb(25, 19, 59);
  text-align: center;
  color: rgb(218, 213, 213);
  font-size: 120%;
}
.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;
    background: $--color-primary;
    color: #fff;
    .userinfo {
      text-align: right;
      padding-right: 35px;
      float: right;
      .userinfo-inner {
        cursor: pointer;
        color: #fff;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }
    .logo {
      //width:230px;
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      border-color: rgba(238, 241, 146, 0.3);
      border-right-width: 1px;
      border-right-style: solid;
      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      width: 230px;
    }
    .logo-collapse-width {
      width: 60px;
    }
    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;
    aside {
      flex: 0 0 230px;
      width: 230px;
      // position: absolute;
      // top: 0px;
      // bottom: 0px;
      .el-menu {
        height: 100%;
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
    }
    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
    }
    .content-container {
      // background: #f1f2f7;
      flex: 1;
      // position: absolute;
      // right: 0px;
      // top: 0px;
      // bottom: 0px;
      // left: 230px;
      overflow-y: scroll;
      padding: 20px;
      .breadcrumb-container {
        //margin-bottom: 15px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }
      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// Home.vue?cf81f1f2